import { Contract } from '../../../types/contract/Contract'
import { DeliverySubscription } from '../../../types/deliverySubscription/DeliverySubscription'

const deliverySubscriptionQueryKeys = {
  all: [{ scope: 'deliverySubscriptions' }] as const,
  list: (contractId: Contract['id']) => [{ scope: 'deliverySubscriptions', contractId }] as const,
  deliveries: (contractId: Contract['id'], id: DeliverySubscription['id']) =>
    [{ scope: 'deliveries', contractId, id }] as const
}

export default deliverySubscriptionQueryKeys
